<template>
  <div>
    <div class="container">

      <div class="columns mt-01">

        <div class="column">
          <div class="video-container">
						<iframe src="https://www.youtube.com/embed/Eh8jHw-75nU" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>

           </div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Informe',
  data () {
    return {

    }
  },
  computed: {
  },
  components: {

  },
  mounted() {

  },
  methods:{

  },
  created :function(){
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Informe.vue